/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { take } from 'rxjs/operators';
import { IDateRange, IMachineFromApi } from 'app/models';
import { MachineService } from 'app/services';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorListPopupComponent, ErrorListPopupModel } from '../error-list-popup/error-list-popup.component';

@Component({
  selector: 'app-machine-info',
  templateUrl: './machine.info.component.html',
  styleUrls: ['./machine.info.component.scss'],
})
export class MachineInfoComponent implements OnInit, OnChanges {
  @Input()
  selectedMachine: IMachineFromApi | null = null;
  @Input()
  dateRange: IDateRange | null = null;

  constructor(
    public dialog: MatDialog,
    private readonly machineService: MachineService
  ) { }

  ngOnInit(): void {
    this.updateSelectedMachine();
  }

  ngOnChanges(changes: any): void {
    if (changes.selectedMachine) {
      this.selectedMachine = changes.selectedMachine.currentValue;
      this.updateSelectedMachine();
    }
  }

  onErrorListButtonClicked() {
    const { customerId, id, name } = this.selectedMachine!!;
    const dialogData = new ErrorListPopupModel(
      customerId,
      id,
      name,
      this.dateRange!!.startDate.toDate(),
      this.dateRange!!.endDate.toDate(),
    );

    this.dialog.open(ErrorListPopupComponent, {
      data: dialogData,
      width: '50%',
      height: '80%',
    });
  }

  private updateSelectedMachine() {
    if (this.selectedMachine && this.selectedMachine.hasImage) {
      this.machineService
        .findMachineById(this.selectedMachine.id)
        .pipe(take(1))
        .subscribe(
          (data) => (this.selectedMachine = data),
          () => console.error
        );
    }
  }
}
